<div class="mb_header">
    <a href="#" class="mb_menu_btn open" (click)="clickMbMenu($event)">
        <i class="fa fa-bars" aria-hidden="true"></i>
    </a>
    <div class="mb_header_logo"></div>
    <a href="#" class="mb_logout_btn" (click)='showLogoutConfirm($event)'>
        <i class="fa fa-power-off" aria-hidden="true"></i>
    </a>
</div>

<div id="header" class="wrapper" (mouseleave)="onMouseLeave($event)" (mouseenter)="onMouseEnter($event)">

    <div class="wrapper-size">
        <div class="header-logo" id='popcheck'>
            <a href="#" (click)="preventNavigation($event)"></a>
        </div>
        <div [ngClass]="{'btn-location-hold':true,'open':showLocationOptions}" (click)="openLocationOptions($event)">
            <a class="btn-green dropdown-toggle" data-toggle="dropdown">
                <i class="icon-location"></i>
                {{areaName}}
                <i class="fa fa-angle-down" aria-hidden="true"></i>
            </a>

            <ul *ngIf="haveAreaOptions" class="dropdown-menu">
                <ng-container *ngFor="let option of userAreaOptions">
                    <li *ngIf="option.value !== currentArea">
                        <a [name]="option.value" (click)="doClickUserAreaAction($event,option)">{{option.label}}</a>
                    </li>
                </ng-container>
            </ul>
        </div>
        <div class="header-func">

            <a href="https://robot.esunbank.com.tw/index.php?eservice=CEOAPP&qaCategory=CEOAPP"
                class="header-func-anchor" target="_blank" [title]="linkTitle1">
                <img src="../../inc/img/icon/iocn_customer_header.png" alt="" width="20">
            </a>

            <a href="#" data-dialog="#sitemap" (click)="openCcmotview($event)" class="header-func-anchor"
                [title]="linkTitle2">
                <i class="fa fa-list-ul"></i>
            </a>



            <div class="language_area" [ngClass]="{'language_area':true,'open':showLangOptions}"
                (click)="openLangOptions($event)">

                <a class="btn-gray language dropdown-toggle" data-toggle="dropdown">
                    {{currentLangItem.label}}
                    <i class="fa fa-angle-down" aria-hidden="true" href="#" (click)="preventNavigation($event)"></i>
                </a>

                <ul *ngIf="languageOptions" class="dropdown-menu">
                    <ng-container *ngFor="let option of languageOptions">
                        <li *ngIf="option.value !== currentLangItem.value">
                            <a [name]="option.value" (click)="changeLang($event,option)">{{option.label}}</a>
                        </li>
                    </ng-container>
                </ul>

            </div>

            <span class="count">
                {{hour}}{{'自動登出'|i18n:'chm00000308':null}}
                <a class="btn-green reload" href="#" (click)='startTimeoutTimer($event)'>
                    <i class="fa fa-repeat" aria-hidden="true"></i>
                </a>
            </span>

            <a href="#" class="btn-green logout" (click)='showLogoutConfirm($event)'>{{'登出'|i18n:'chm00002815':null}}
                <i class="icon-logout"></i>
            </a>

        </div>
    </div>

</div>


<div class="float-component">
    <ul class="float-list list-group" id="float-list1"
        [ngClass]="{'display-inline-block': showHistory, 'display-none': !showHistory}">

        <li class="list-header">{{'瀏覽紀錄'|i18n:'chm00005734':null}}</li>
        <li *ngFor="let item of historys" class="list-group-item">
            <a href="#" (click)="clickHistory($event,item)">
                {{item.name}}
            </a>
        </li>
    </ul>

    <ul class="float-list list-group" id="float-list2"
        [ngClass]="{'display-block': showFavourite, 'display-none': !showFavourite}">
        <li class="list-header">{{'常用功能'|i18n:'chm00005750':null}}
            <a class="btn" data-dialog="#my_faylist" (click)="openCustomFavourite($event)">
                <i class="fa fa-cog" aria-hidden="true"></i>
            </a>
        </li>
        <li *ngFor="let item of favoriteTaskList" class="list-group-item">
            <a href="#" (click)="clickFavourite($event,item)">
                {{item.name}}
            </a>
        </li>
    </ul>

    <div class="float-btn-container">

        <div class="float-btn-wrapper">
            <div id="float1" class="float-btn open" (click)="openHistory($event)">
                <i class="fa" aria-hidden="true"></i>
                <!-- <img src="./inc/img/icon/home-w.png"/> -->
            </div>
        </div>
        <div class="float-btn-wrapper">
            <div id="float2" class="float-btn open" (click)="openFavourite($event)">
                <i class="fa fa-heart" aria-hidden="true"></i>
                <!-- <img src="./inc/img/icon/home-w.png"/> -->
            </div>
        </div>
    </div>
</div>

<timeout-popup (timerCallback)="timerCallback($event)">
</timeout-popup>

<gib-favorite-popup [favoriteTaskList]="favoriteTaskList" [display]="showCustomFavourite"
    (callback)="onFavoriteCallBack($event)"></gib-favorite-popup>
<gib-logout-confirm-popup [display]="displayLogoutConfirm" (callback)="closeLogoutConfirm($event)">
</gib-logout-confirm-popup>


<gib-ccmotview-popup [display]="displayCcmotview" (onClick)="doClickCcmotviewPopup($event)"
    (callBack)="closeCcmotviewPopup($event)"></gib-ccmotview-popup>